import React, { useContext, useState } from 'react';


import Modal from 'components/modal';
import Button from 'components/button';
import Spacer from 'components/spacer';
import InputContainer from 'components/input-container';

import If from 'conditionals/if';

import LocaleContext from 'contexts/locale-context';

import './index.css';

let cb = null;

const withConfirm = () => Component => (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState(null);
    const [title, setTitle] = useState(null);
    const [email, setEmail] = useState(null);

    const { translations } = useContext(LocaleContext);
    const jsTranslations = translations.js;

    const openEmail = ({ title, message, email } = {}) => new Promise(resolve => {
        setIsOpen(true);
        setMessage(message)
        setTitle(title)
        setEmail(email)
        cb = resolve;
    })

    const closeConfirm = () => setIsOpen(false);

    const onSubmit = (resp) => {
        if (cb) cb(resp);
        setIsOpen(false);
    }

    return (
        <div className='withconfirm'>
            <Component
                {...props}
                openEmail={openEmail}
                closeConfirm={closeConfirm}
            />
            <Modal
                isOpen={isOpen}
                onRequestClose={closeConfirm}
            >
                <div className='withconfirm__modal'>
                    {title &&
                        <>
                            <h3 className='withconfirm__modal__text withconfirm__modal__title'>
                                {title}
                            </h3>
                        </>
                    }

                    {message &&
                        <>
                            <p className='withconfirm__modal__text'>{message}</p>
                        </>
                    }

                    <form
                        onSubmit={e=> {
                            e.preventDefault()
                            if (email && /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
                                onSubmit(email)
                            }
                        }}
                    >
                        
                        <If condition={isOpen}>
                            <InputContainer>
                                {({ class: className }) => {
                                    return (
                                        <input
                                            value={email}
                                            placeholder={jsTranslations.your_email}
                                            type='email'
                                            required
                                            className={className}
                                            onChange={e => setEmail(e.target.value)}
                                        />
                                    )
                                }}
                            </InputContainer>
                        </If>

                        <Button
                            type='submit'
                        >
                            {jsTranslations.submit}
                        </Button>
                    </form>
                </div>
            </Modal>
        </div>
    )
};

export default withConfirm;